
import { useIsMobile } from '@/hooks/use-mobile';
import { LeadsTableDesktop } from './LeadsTableDesktop';
import { LeadsTableMobile } from './LeadsTableMobile';
import { LeadsTableProps } from './types';
import { supabase } from '@/integrations/supabase/client';

export function LeadsTable(props: LeadsTableProps) {
  const isMobile = useIsMobile();
  
  return isMobile ? <LeadsTableMobile {...props} /> : <LeadsTableDesktop {...props} />;
}
